export default __webpack_public_path__ + "static/media/Optum.76cffe46.svg";